import { MetricsDataActionTypes, MetricsDataRequestStartAction } from './ActionTypes';

export const metricsDataRequestStart = (ids: ReadonlyArray<string>): MetricsDataRequestStartAction => {
  return {
    type: MetricsDataActionTypes.REQUEST_START,
    ids,
  };
};
